import { closeConsultantCianChat, openConsultantCianChat, openErrorMessage, setChatLoading } from './actions';
import { onOpenChatPopup } from '../../containers/ConsultantChatButtonContainer/analytics/analytics';
import { EChatRole } from '../../repositories/newbuilding-consultants/entities/chat_user1/ChatUser1';
import { ESourcePage } from '../../repositories/newbuilding-consultants/entities/get_or_create_chat/PublicV1GetOrCreateChatRequest';
import { getRegionId } from '../../selectors/analytics';
import { getFullUrl, getGaLabel } from '../../selectors/newbuilding';
import { getUser } from '../../selectors/user';
import { fetchConsultantCianChat } from '../../services/fetchConsultantCianChat/fetchConsultantCianChat';
import { TThunkAction } from '../../types/redux/thunk';
import { getUserAction } from '../user/getUserAction';

export const onConsultantCianCloseNoAuth = (): TThunkAction => {
  return dispatch => {
    dispatch(closeConsultantCianChat());
  };
};

export const requestChat = (): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    dispatch(setChatLoading());

    const state = getState();
    const customLabel = getGaLabel(state);
    const regionId = getRegionId(state);
    const fullUrl = getFullUrl(state);
    const user = getUser(state);

    if (!user) {
      await dispatch(getUserAction());
    }

    const { httpApi, logger } = context;
    const data = await fetchConsultantCianChat({
      httpApi,
      logger,
      parameters: { pageUrl: fullUrl, sourcePage: ESourcePage.NewbuildingCard },
    });

    /* istanbul ignore else */
    if (data && data.chatId) {
      const users = data.users ?? [];
      const chatInitiator = users.find(user => user.chatRole === EChatRole.Initiator);

      dispatch(openConsultantCianChat(data.chatId));

      onOpenChatPopup({
        customPageURL: customLabel,
        chatId: data.chatId,
        botId: 3,
        ownerId: chatInitiator?.userId,
        regionId,
      });
    } else {
      dispatch(openErrorMessage());
    }
  };
};
